import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import { getCurrency } from '../../../../helpers/currencies'

import Input from '../../../Core/Input/Input'
import Button from '../../../Core/Button/Button'
import RadioButton from '../../../Core/Radio'

const TargetsForm = ({targets, onChange, onSubmit }) => {
  const { t } = useTranslation()

  const companyInfo = useSelector(state => state.company?.companyInfo)
  const currency = getCurrency(companyInfo?.currency)

  const handleInputChange = (field) => (event) => {
    const { value } = event.target
    onChange(field, value)
  }

  const handleGoalTypeChange = (event) => {
    onChange('target_type', event.target.value)
  }

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit()
    }
  }

  const goalOptions = [
    { id: 'daily', label: t('Daily goal') },
    { id: 'monthly', label: t('Monthly goal (divided by days)') }
  ]

  return (
    <div className={styles.container}>
      <div className={styles.formSection}>
        <RadioButton
          options={goalOptions}
          checked={targets.target_type}
          onChange={handleGoalTypeChange}
        />
      </div>
      <div className={styles.formSection}>
        <label htmlFor='amount' className={styles.fieldLabel}>{targets.target_type === 'daily' ? t('Daily sales target') : t('Monthly sales target')} ({currency.symbol})</label>
        <Input
          id='amount'
          type='number'
          placeholder='0.00'
          value={targets.amount}
          onChange={handleInputChange('amount')}
          fullWidth
        />
      </div>

      <div className={styles.formSection}>
        <label htmlFor='material_cost' className={styles.fieldLabel}>{t('Raw material cost target')} (%)</label>
        <Input
          id='material_cost'
          type='number'
          placeholder='0.00'
          value={targets.material_cost}
          onChange={handleInputChange('material_cost')}
          fullWidth
          min='0'
          max='100'
        />
      </div>

      <div className={styles.formSection}>
        <label htmlFor='employee_cost' className={styles.fieldLabel}>{t('Labor cost target')} (%)</label>
        <Input
          id='employee_cost'
          type='number'
          placeholder='0.00'
          value={targets.employee_cost}
          onChange={handleInputChange('employee_cost')}
          fullWidth
          min='0'
          max='100'
        />
      </div>

      <div className={styles.buttonContainer}>
        <Button
          primary
          onClick={handleSubmit}
          fillWidth
        >
          {t('Save')}
        </Button>
      </div>
    </div>
  )
}

export default TargetsForm
